import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { FaEnvelope, FaSuitcase, FaFileAlt } from "react-icons/fa";
import { HiHome } from "react-icons/hi";
import { motion } from "framer-motion";
import { AiFillProfile } from "react-icons/ai";
import {PiSuitcaseSimpleFill} from "react-icons/pi";
import {FaProjectDiagram} from "react-icons/fa";


function Navbar() {
  const [showPopupNav, setShowPopupNav] = useState(false);
  const [scrollDirection, setScrollDirection] = useState("up");
  const [lastScrollTop, setLastScrollTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;

      // Show popup nav when scrolled past 100px
      if (currentScrollPos > 100) {
        setShowPopupNav(true);
      } else {
        setShowPopupNav(false);
      }

      // Determine scroll direction
      if (currentScrollPos > lastScrollTop) {
        setScrollDirection("down");
      } else {
        setScrollDirection("up");
      }

      setLastScrollTop(currentScrollPos <= 0 ? 0 : currentScrollPos);
    };

    const handleDoubleClick = () => {
      setShowPopupNav(true); // Show navbar on double click
      setTimeout(() => {
        setShowPopupNav(false); // Hide after 3 seconds
      }, 3000);
    };

    // Check if on homepage
    const isHomepage = window.location.pathname === "/" || window.location.pathname === "/home";
    if (isHomepage) {
      setShowPopupNav(true); // Show navbar immediately on homepage
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("dblclick", handleDoubleClick);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("dblclick", handleDoubleClick);
    };
  }, [lastScrollTop]);
  return (
    <>


      {/* Pop-up Navbar */}
      <div className="fixed top-0 w-full flex justify-center z-40">
        <motion.nav
          className={`w-[40%] sm:w-[90%] md:w-[80%] rounded-full border mt-2 bg-black/80 backdrop-blur-sm h-12 flex justify-center items-center text-white px-8 shadow-lg`}
          initial={{ y: -100 }}
          animate={{ 
            y: showPopupNav ? (scrollDirection === "up" ? 0 : -100) : -100 
          }}
          transition={{ type: "spring", stiffness: 100, damping: 20 }}
        >
          
          <div className="flex space-x-10 sm:space-x-1 md:space-x-6 justify-between w-full text-3xl sm:text-[16px] md:text-2xl items-center">
            <Link 
              to="hero" 
              spy={true} 
              smooth={true} 
              offset={-8000} 
              duration={3000} 
              className="hover:text-cyan-400 transition-colors cursor-pointer"
              activeClass="text-cyan-400"
            >
              <HiHome />
            </Link>
            <Link 
              to="about" 
              spy={true} 
              smooth={true} 
              offset={-40} 
              duration={1000} 
              className="hover:text-cyan-400 transition-colors cursor-pointer"
              activeClass="text-cyan-400"
            >
              <AiFillProfile/>
            </Link>
            <Link 
              to="experience" 
              spy={true} 
              smooth={true} 
              offset={0} 
              duration={1000} 
              className="hover:text-cyan-400 transition-colors cursor-pointer"
              activeClass="text-cyan-400"
            >
              
              <PiSuitcaseSimpleFill />
              </Link>
            <Link 
              to="projects" 
              spy={true} 
              smooth={true} 
              offset={-50} 
              duration={1000} 
              className="hover:text-cyan-400 transition-colors cursor-pointer"
              activeClass="text-cyan-400"
            >
              <FaProjectDiagram />
            </Link>
            <Link 
              to="skills" 
              spy={true} 
              smooth={true} 
              offset={0} 
              duration={1000} 
              className="hover:text-cyan-400 transition-colors cursor-pointer"
              activeClass="text-cyan-400"
            >
              <FaSuitcase />
            </Link>
            <Link 
              to="resume" 
              spy={true} 
              smooth={true} 
              offset={20} 
              duration={1000} 
              className="hover:text-cyan-400 transition-colors cursor-pointer"
              activeClass="text-cyan-400"

            >
              <FaFileAlt />
            </Link>
            <Link 
              to="contact" 
              spy={true} 
              smooth={true} 
              offset={0} 
              duration={1000} 
              className="hover:text-cyan-400 transition-colors cursor-pointer"
              activeClass="text-cyan-400"

            >
              <FaEnvelope />
            </Link>
          </div>
        </motion.nav>
      </div>
    </>
  );
}

export default Navbar;